import React           from 'react';
import {Alert, Button} from '@aws-amplify/ui-react';

interface FreePlanAlertProps {
    onUpgradeClick: () => void;
}

const SubscribePromo: React.FC<FreePlanAlertProps> = ({onUpgradeClick}) => {
    return (
        <div className="container d-flex justify-content-center lead">
            <Alert hasIcon={false} variation="info" heading="" className="p-5 promo-alert">
                Some features are not available. Upgrade to the Pro subscription and access:
                <ul className="lead mt-4 ms-5 custom-bullet-list">
                    <li>Access to restricted phrases and questions</li>
                    <li>Pin-point search by categories</li>
                    <li>Detailed data from research studies</li>
                    <li>Additional privacy settings</li>
                </ul>
                <div className="mt-5 d-flex justify-content-center">
                    <Button variation="primary" size={"large"} onClick={onUpgradeClick}>
                        Subscribe to Pro
                    </Button>
                </div>
            </Alert>
        </div>

    );
};

export default SubscribePromo;
